import { gql } from "@apollo/client";
import { WarehouseItem as warehouseItem } from "../fragments";
import SEARCH_SYNOPSIS_TERMS from "../fragments/SearchSynopsisTerms";

const FETCH_WAREHOUSE_ITEM = props => gql`
  query FetchWarehouseItem($id: Int!) {
    warehouseItem(id: $id) {
      ${warehouseItem(props)}
    }
  }
`;

const FETCH_WAREHOUSE_ITEMS_V2 = props => gql`
  query FetchWarehouseItemsV2($input: AdvWarehouseItemFilterInput!) {
    warehouseItemsV2(input: $input) {
      count
      edges {
        ${warehouseItem(props)}
      }
      sqlQuery
    }
  }
`;

const WAREHOUSE_ITEM_LIST_FIELDS = `
  count
  edges {
    id
    category {
      description
    }
    container
    description
    destroyed
    dimd
    dimh
    dimw
    instance {
      id
      name
    }
    itemSite {
      id
      locref
      siteId
      location {
        id
        description
      }
      site {
        id
        name
      }
    }
    weightType {
      id
      name
    }
    weight
  }
  sqlQuery
`;

const FETCH_WAREHOUSE_ITEMS_LIST = props => gql`
  query FetchWarehouseItemsList($input: AdvWarehouseItemFilterInput!) {
    warehouseItemsV2(input: $input) {
      ${WAREHOUSE_ITEM_LIST_FIELDS}
    }
  }
`;

// The results page also shows the search as removable tags.
const FETCH_WAREHOUSE_ITEMS_SEARCH_RESULTS = gql`
  query FetchWarehouseItemsSearchResults($input: AdvWarehouseItemFilterInput!) {
    warehouseItemsV2(input: $input) {
      ${WAREHOUSE_ITEM_LIST_FIELDS}
      ${SEARCH_SYNOPSIS_TERMS}
    }
  }
`;

const FETCH_WAREHOUSE_ITEMS_LOCATION_SUMMARY = gql`
  query FetchWarehouseItemsLocationSummary(
    $input: WarehouseItemSelectionInput!
  ) {
    warehouseItemsLocationSummary(input: $input) {
      fromLocationNames
      itemCount
      siteIds
    }
  }
`;

const FETCH_WAREHOUSE_MGROUP = gql`
  query FetchWarehouseMGroup {
    warehouseMGroup {
      mgroups
    }
  }
`;

export {
  FETCH_WAREHOUSE_ITEM,
  FETCH_WAREHOUSE_ITEMS_V2,
  FETCH_WAREHOUSE_ITEMS_LIST,
  FETCH_WAREHOUSE_ITEMS_LOCATION_SUMMARY,
  FETCH_WAREHOUSE_ITEMS_SEARCH_RESULTS,
  FETCH_WAREHOUSE_MGROUP,
};
